export type DomainErrorCode =
  | "VALIDATION_FAILED"
  | "INVALID_STATE"
  | "UNSUPPORTED_SCHEMA_VERSION";

export interface ValidationIssue {
  readonly path: string;
  readonly message: string;
  readonly code?: string;
  readonly entityId?: string;
}

export class DomainError extends Error {
  public constructor(
    public readonly code: DomainErrorCode,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = new.target.name;
  }
}

export class ValidationError extends DomainError {
  public constructor(public readonly issues: readonly ValidationIssue[]) {
    super(
      "VALIDATION_FAILED",
      issues.map((issue) => `${issue.path}: ${issue.message}`).join("; "),
    );
  }
}

export class InvalidStateError extends DomainError {
  public constructor(message: string) {
    super("INVALID_STATE", message);
  }
}

export class UnsupportedSchemaVersionError extends DomainError {
  public readonly compatibility: "unsupported-old" | "future";
  public readonly readOnlyRequired: boolean;

  public constructor(
    public readonly actual: number,
    public readonly supported: number,
    compatibility: "unsupported-old" | "future" =
      actual > supported ? "future" : "unsupported-old",
  ) {
    super(
      "UNSUPPORTED_SCHEMA_VERSION",
      compatibility === "future"
        ? `Content schema version ${actual} is newer than supported version ${supported}; open read-only with a newer application`
        : `Content schema version ${actual} is too old; earliest supported migration target is ${supported}`,
    );
    this.compatibility = compatibility;
    this.readOnlyRequired = compatibility === "future";
  }
}
